import { render, staticRenderFns } from "./ProdutividadeResumoExibicao.vue?vue&type=template&id=5d37b893&scoped=true&lang=pug&"
import script from "./ProdutividadeResumoExibicao.vue?vue&type=script&lang=js&"
export * from "./ProdutividadeResumoExibicao.vue?vue&type=script&lang=js&"
import style0 from "./ProdutividadeResumoExibicao.vue?vue&type=style&index=0&id=5d37b893&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d37b893",
  null
  
)

export default component.exports